<a href=""><img src="../../assets/img/slider.webp" alt="Garage de MontPlaisir" class="slider" /></a>

<div class="col-12 p-0">
    <p-menubar [model]="items">
        <ng-template pTemplate="start">
            <div class="menuText">
                Menu
            </div>
        </ng-template>
    </p-menubar>

    <p-scrollTop></p-scrollTop>
</div>